import { INodataProps } from "./Model";
import { NodataWrapper } from "./Style";
import { useTranslation } from "react-i18next";
import { Text } from "..";
import { IconNoDataLarge, IconNoDataMedium } from "./Icon";

const NoData = (props: INodataProps) => {
  const { t } = useTranslation();

  const renderIcon = () => {
    if (props.isShowIcon) {
      if (props.size === "large") {
        return <IconNoDataLarge theme={props.theme} />;
      }
      return <IconNoDataMedium theme={props.theme} />;
    }
    return null;
  };

  return (
    <NodataWrapper className='NodataWrapper' $size={props.size}>
      {renderIcon()}
      <Text className='content'>
        {props.content ? props.content : t("nodata.message", "No data available.")}
      </Text>
      {props.description && <Text className='description'>{props.description}</Text>}
    </NodataWrapper>
  );
};

export default NoData;
